import { render, staticRenderFns } from "./IrrUserListComponent.vue?vue&type=template&id=3de5c127"
import script from "./IrrUserListComponent.vue?vue&type=script&lang=js"
export * from "./IrrUserListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports